/**
 * The PO HEADER's status vocabulary — one owner (CR-7412).
 *
 * Aaron, 18 Sep 2026: *"open > in progress > closed i think thats simple enough"*, and
 * of the three values dropped, *"ack delivered can never be used"*.
 *
 * THIS MODULE EXISTS BECAUSE THE GRID WAS LYING, AND I ALMOST PHOTOGRAPHED THE LIE AS
 * EVIDENCE. Four surfaces rendered the header status and the fourth was not a map at
 * all — `POHeadersTab.tsx` had `{order.status === 'closed' ? 'Closed' : 'Open'}`
 * inline, a hardcoded binary. Two consequences:
 *
 *   1. It has ALWAYS said "Open" for anything not closed, so a screenshot of the grid
 *      captioned "the header reads Open where it used to say Sent" proves nothing about
 *      this item. I had taken that shot before checking (GUIDE P3 — ask what a green,
 *      or here a picture, would look like if it could not express the change at all).
 *   2. It collapsed `in_progress` into "Open", so the MIDDLE state of Aaron's three was
 *      invisible on the surface a buyer actually reads. The three-state ruling was not
 *      delivered until this module existed.
 *
 * `sent` keeps its stored spelling and is LABELLED Open: the value is read by
 * `sync_po_status`, both ERP importers, the GRN header sync and
 * `po_dashboard_views.metrics`, and renaming a column value across four tenants to
 * change one word on screen is not a trade worth making.
 *
 * The three retired values keep entries here deliberately. They are DORMANT — nothing
 * writes them and no row on any tenant holds one — but a map that omits them would
 * print a raw database string for a stray row, which is the CR-7305 fault and is not
 * worth reintroducing on the way out.
 */

/** What each header status is called on screen. */
export const PO_HEADER_STATUS_LABELS: Record<string, string> = {
  sent: 'Open',
  in_progress: 'In Progress',
  closed: 'Closed',
  // DORMANT (CR-7412) — kept so a stray row reads as a word, not a database value.
  draft: 'Open',
  acknowledged: 'Open',
  delivered: 'Closed',
};

/** The badge classes, keyed the same way. */
export const PO_HEADER_STATUS_CLASSES: Record<string, string> = {
  sent: 'bg-green-100 text-green-800',
  in_progress: 'bg-amber-100 text-amber-800',
  closed: 'bg-slate-100 text-slate-800',
  draft: 'bg-green-100 text-green-800',
  acknowledged: 'bg-green-100 text-green-800',
  delivered: 'bg-slate-100 text-slate-800',
};

/** The label for a header status, falling back to the raw value rather than to blank. */
export function poHeaderStatusLabel(status?: string | null): string {
  if (!status) return '-';
  return PO_HEADER_STATUS_LABELS[status] ?? status;
}

/** The badge classes for a header status. */
export function poHeaderStatusClass(status?: string | null): string {
  return PO_HEADER_STATUS_CLASSES[status || ''] ?? 'bg-gray-100 text-gray-800';
}
